import { TemplateResult, LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import globalStyles from './styles/outline-link.global.pcss?inline';
import encapsulatedStyles from './styles/outline-link.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-link';

export const linkVariants = ['chip', 'animated-light', 'animated-dark', 'icon-link'] as const;
export type LinkVariant = (typeof linkVariants)[number];

/**
 * The Outline Link component
 *
 * A reusable LitElement component for links.
 *
 * @element outline-link
 * @extends LitElement
 * @slot - Default slot for <a> tags.
 */
@customElement(componentName)
export class OutlineLink extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  @property({type: String})
  variant: LinkVariant;

  render(): TemplateResult {
    return html`
      <slot></slot>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineLink;
  }
}
